module Meevo.Plugins.TransactionEditor {
    export class DeferredVoidModalController {
        drawers: Meevo.Model.DrawerListItem[] = [];

        deferredVoidDrawer: string;
        deferredVoidClient: Meevo.Model.ClientListItem;

        static $inject = [
            'sale',
            'salePayment',
            'paymentLineDisplayName',
            'houseEmployee',
            'paymentType',
            '$q',
            '$translate',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.AppSettings',
            "meevo.plugins.register.RegisterClientAccountService",
        ];

        constructor(
            public sale: Model.Sale,
            public salePayment: Model.SalePayment,
            public paymentLineDisplayName: string,
            public houseEmployee: Model.EmployeeListItem,
            public paymentType: Model.PaymentTypeListItem,
            private $q: angular.IQService,
            private $translate: angular.translate.ITranslateService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            private modalService: Meevo.Components.Modal.IModalService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private registerClientAccountService: Meevo.Plugins.Register.RegisterClientAccountService
        ) {
            this.initialize();
        }

        private initialize() {
            this.getDrawerList().then(drawers => {
                this.drawers = drawers;

                // if only 1 drawer exists, pre-select it
                if (drawers.length === 1) {
                    this.deferredVoidDrawer = drawers[0].id;
                }
            });

            // if only 1 client exists, pre-select it
            const uniqueClients = _.chain(this.sale.saleLines).pluck('clientId').uniq().value();
            if (uniqueClients.length === 1) {
                const saleLine = _(this.sale.saleLines).find(saleLine => saleLine.clientId === uniqueClients[0]);
                if (saleLine) {
                    this.deferredVoidClient = saleLine.client;
                }
            }
        }

        private getDrawerList() {
            const request = {
                criteria: { useUserId: true }
            };

            return this.dataService.customMethodData("api/drawer/list", "POST", request).then(response => {
                return response.data.filter(drawer => drawer.drawerState === Model.DrawerStateEnum.Open);
            });            
        }

        private isValid(): boolean {
            return !!(this.deferredVoidDrawer && this.deferredVoidClient);
        }

        private paymentRequestDeferredUpdate(paymentLine: Meevo.Model.SalePayment): ng.IPromise<any> {
            const request = {
                isDeferredVoidInserted: true
            };
            const url = `api/paymentRequest/${paymentLine.paymentRequestId}/deferredUpdate`;
            return this.dataService.customMethodData(url, "POST", request);
        }

        private deferredVoid(client: Meevo.Model.ClientListItem, drawerId: string, accountBalance: number, creditAmount: number): ng.IPromise<any> {
            const deferredVoidSale: Model.Sale = {
                saleLines: [],
                paymentLines: [],
                subTotal: 0,
                total: 0,
                changeDue: 0,
                tipLines: [],
                saleStage: Model.SaleStageEnum.Finalize,
                tip: 0,
                tax: 0,
                taxIncluded: 0,
                onHoldIds: {},
                mergeClientIds: [],
                noLinkMergeClientIds: [],
                totalPrepaidTip: 0,
                locale: this.appSettings.APP_COUNTRYID,
                timeFormat: this.appSettings.APP_TIME_FORMAT
            };

            // create sale
            this.registerClientAccountService.generateClientAccountSaleLines(
                deferredVoidSale, 
                client, 
                creditAmount,
                accountBalance, 
                this.houseEmployee
            );

            // add payment
            let payment = {
                __type: "Millennium.Meevo.Register.Contracts.Model.SalePaymentDeferredVoid, Millennium.Meevo.Register.Contracts.Model",
                paymentTypeId: this.paymentType.id,
                amount: creditAmount,
                paymentCategory: this.paymentType.paymentCategory,
                paymentSubCategory: this.paymentType.paymentSubCategory,
                voidSaleDate: this.sale.saleDate,
                voidSaleId: this.sale.id,
                voidSalePaymentId: this.salePayment.id,
            };

            deferredVoidSale.paymentLines.push(payment);

            // insert sale
            this.busyService.start();
            let deferred = this.$q.defer();
            this.dataService.add("drawer", deferredVoidSale, new Guid(drawerId), "sale")
                .then((response: Model.Sale) => {
                    this.paymentRequestDeferredUpdate(this.salePayment)
                        .then(() => {
                            deferred.resolve(response);
                        });
                })
                .finally(() => {
                    this.busyService.stop();
                });
            return deferred.promise;
        }

        continue() {
            if (!this.isValid()) {
                return;
            }

            return this.getBalance(this.deferredVoidClient).then(clientBalance => {
                if (!clientBalance.allowChargesCreditOnAccount) {
                    const message = this.$translate.instant("LABEL_CLIENT_ACCOUNT_NOT_ENABLED");
                    this.modalService.alert(message, Meevo.Components.Modal.ModalTranslationModes.DoNotTranslate, true);
                    this.deferredVoidClient = undefined;
                    return;
                }

                this.busyService.start();
                const creditAmount = Math.abs(this.salePayment.amount);
                this.deferredVoid(this.deferredVoidClient, this.deferredVoidDrawer, clientBalance.accountBalance, creditAmount)
                    .then((response) => {
                        this.close(response);
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            });
        }

        close(response) {
            this.modalService.hideWithResponse(response);
        }

        cancel() {
            this.modalService.hide();
        }

        private getBalance(client: Meevo.Model.ClientListItem) {
            if (!client) {
                return;
            }

            return this.dataService.getItem("client", new Guid(client.id), "accountbalance").then((response: any) => {
                return {
                    allowChargesCreditOnAccount: response.allowChargesCreditOnAccount,
                    accountBalance: +response.accountBalance
                };
            });
        }        
    }

    angular.module("meevo.plugins.transactionEditor")
        .controller("meevo.plugins.transactionEditor.DeferredVoidModalController", DeferredVoidModalController);
}
